import React, {createContext, useContext, useMemo} from 'react'

export interface ContextDropdownProps {
  setVisibility?: (visible: boolean) => void
  isVisible?: boolean
}

const ContextDropdownContext = createContext<ContextDropdownProps>({
  setVisibility: undefined,
  isVisible: false
})

export interface ContextDropdownProviderProps {
  setVisibility?: (visible: boolean) => void
  isVisible?: boolean
  children: React.ReactNode
}

/**
 * Provide ability to close dropdown from any child component. It is important for shared components that are used in platform.
 * @param close
 * @param children
 * @constructor
 */
export const ContextDropdownProvider = ({
  setVisibility,
  isVisible,
  children
}: ContextDropdownProviderProps) => {
  const value = useMemo(
    () => ({setVisibility, isVisible}),
    [setVisibility, isVisible]
  )
  return (
    <ContextDropdownContext.Provider value={value}>
      {children}
    </ContextDropdownContext.Provider>
  )
}

export const useContextDropdown = (): ContextDropdownProps => {
  return useContext(ContextDropdownContext)
}
